import * as React from "react";

import ReploLogoBadge from "@svg/logo-badge";

interface LogoProps {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  "aria-hidden"?: boolean;
}

const LogoBadge: React.FC<LogoProps> = (props) => {
  return <ReploLogoBadge {...props} />;
};

export default LogoBadge;
